import {DelimitedArrayParam, NumberParam, StringParam} from 'use-query-params';

export const queryFiltersSchema = {
  search: StringParam,
  accountId: StringParam,
  acquirer: StringParam,
  processor: StringParam,
  customerEmail: StringParam,
  customerName: StringParam,
  customerPhone: StringParam,
  currency: StringParam,
  id: StringParam,
  authorizationCode: StringParam,
  orderId: StringParam,
  providerReferenceId: StringParam,
  statusCode: StringParam,
  paymentMethodCardLast4: StringParam,
  paymentMethodCardBrand: StringParam,
  paymentMethodMethod: StringParam,
  paymentMethodCardThreeDSecure: StringParam,
  paymentMethodCardThreeDSecureFlow: StringParam,
  paymentMethodBizumIntegrationType: StringParam,
  paymentMethodCardTokenizationMethod: StringParam,
  paymentMethodCardFingerprint: StringParam,
  subscriptionId: StringParam,
  sequenceId: StringParam,
  sessionIp: StringParam,
  sessionFingerprint: StringParam,
  shopName: StringParam,
  shopCountry: StringParam,
  createdAt: DelimitedArrayParam,
  traceDetailsSource: StringParam,
  masterAccountId: StringParam,
  billingPlan: StringParam,
  amount: NumberParam,
  amountOperator: StringParam,
  storeId: StringParam,
  pointOfSaleId: StringParam,
  fraudDetectorScore: NumberParam
};
